import {authenticationService} from "@/container";

/**
 * End the session, here and in the shell.
 */
export const endSession = async (): Promise<void> => {
    await authenticationService().logout();
    window.ipcRenderer?.send('unauthenticated');
};
